import { instance as axios } from "@/store/_AXIOS"

const TABLE = "/at/"
let isClicked = false

// initial state
const state = {
  data: [],
  clients: []
}

// getters
const getters = {
  getAll: state => {
    return state.data
  },
  getById: state => id => {
    if (
      !id ||
      state.data.length === 0 ||
      typeof state.data.find(el => {
        return el.id_at === id
      }) == "undefined"
    )
      return "-"
    return state.data.find(el => {
      return el.id_at === id
    }).nome
  },
  getClients: state => state.clients
}

// actions
const actions = {
  get({ commit }, params) {
    return axios
      .get(TABLE)
      .then(res => {
        return commit("setData", res?.data?.data || null);
        // _DECODE(res.data.data).then(r => {
        //   if (r) commit("setData", r)
        //   else commit("setData", null)
        // })
      })
      .catch(err => {
        commit("setData", null)
      })
  },

  getAllClients({ commit }, params) {
    return axios
      .get(TABLE+'clients')
      .then(res => {
        return commit("setClients", res?.data?.data || null);
      })
      .catch(err => {
        commit("setClients", null)
      })
  },

  print({ commit }, params) {
    return axios
      .post("/pdf/print/", { data: params })
      .then(res => {
        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  insert({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .post(TABLE, { data: params })
      .then(res => {
        dispatch("get")
        dispatch("getAllClients")

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  update({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .put(TABLE, { data: params })
      .then(res => {
        dispatch("get")
        dispatch("getAllClients")

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

   updatestate({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .put(TABLE+'state', { data: params })
      .then(res => {
        dispatch("get")

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  },

  delete({ dispatch, rootState }, params) {
    if (isClicked) return undefined
    isClicked = true

    setTimeout(() => {
      isClicked = false
    }, this._vm.$holdTime)
    return axios
      .delete(TABLE + params.id)
      .then(res => {
        dispatch("get")
        dispatch("getAllClients")

        return !res.data.errors
      })
      .catch(err => {
        return false
      })
  }
}

// mutations
const mutations = {
  setData(state, data) {
    state.data = data ? data : []
  },
  setClients(state, data) {
    state.clients = data ? data : []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
